import React from "react";
import UsersTable from "../components/UsersTable";

const UsersPage = () => {
  return <UsersTable />;
};

export default UsersPage;
